
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1dlbc_93",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1dlbc_110",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1dlbc_110",
  "root-variant-h1-refresh": "awsui_root-variant-h1-refresh_2qdw9_1dlbc_113",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1dlbc_116",
  "root-has-description": "awsui_root-has-description_2qdw9_1dlbc_116",
  "root-variant-h2-refresh": "awsui_root-variant-h2-refresh_2qdw9_1dlbc_119",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1dlbc_122",
  "root-variant-h3-refresh": "awsui_root-variant-h3-refresh_2qdw9_1dlbc_125",
  "root-no-wrap": "awsui_root-no-wrap_2qdw9_1dlbc_128",
  "main": "awsui_main_2qdw9_1dlbc_132",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1dlbc_139",
  "main-variant-h1-refresh": "awsui_main-variant-h1-refresh_2qdw9_1dlbc_142",
  "main-variant-h2": "awsui_main-variant-h2_2qdw9_1dlbc_148",
  "main-variant-h3": "awsui_main-variant-h3_2qdw9_1dlbc_148",
  "main-variant-h2-refresh": "awsui_main-variant-h2-refresh_2qdw9_1dlbc_154",
  "actions": "awsui_actions_2qdw9_1dlbc_161",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1dlbc_165",
  "actions-variant-h1-refresh": "awsui_actions-variant-h1-refresh_2qdw9_1dlbc_168",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1dlbc_171",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1dlbc_171",
  "actions-variant-h2-refresh": "awsui_actions-variant-h2-refresh_2qdw9_1dlbc_177",
  "actions-variant-h3-refresh": "awsui_actions-variant-h3-refresh_2qdw9_1dlbc_180",
  "title": "awsui_title_2qdw9_1dlbc_184",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1dlbc_190",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1dlbc_193",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1dlbc_193",
  "title-variant-h2-refresh": "awsui_title-variant-h2-refresh_2qdw9_1dlbc_199",
  "info": "awsui_info_2qdw9_1dlbc_206",
  "description": "awsui_description_2qdw9_1dlbc_210",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1dlbc_215",
  "description-variant-h1-refresh": "awsui_description-variant-h1-refresh_2qdw9_1dlbc_220",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1dlbc_223",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1dlbc_228",
  "description-variant-h3-refresh": "awsui_description-variant-h3-refresh_2qdw9_1dlbc_234",
  "heading": "awsui_heading_2qdw9_1dlbc_238",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1dlbc_247",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1dlbc_252",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1dlbc_257",
  "heading-text": "awsui_heading-text_2qdw9_1dlbc_263",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1dlbc_266",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1dlbc_274",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1dlbc_282",
  "counter": "awsui_counter_2qdw9_1dlbc_291"
};
  